var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collection"},[_c('div',{staticClass:"row mx-2"},_vm._l((_vm.items),function(item){return _c('ItemCard',{key:item.id,staticClass:"col-lg-3 col-md-6 col-sm-6 mb-4 item-card",attrs:{"item":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }